// extracted by mini-css-extract-plugin
export default {"prematchPeriodLabel":"bDC2f"};